"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[187],{

/***/ 43038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Terms; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96588);
/* harmony import */ var _components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84247);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86879);




function Terms() {
    var slug = (0,_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    var REWARDS_TERMS_CONTENT = _brand_components__WEBPACK_IMPORTED_MODULE_1__/* .COMPONENT_CONFIG.MODAL_HOW_REWARDS_WORK */ .P.MODAL_HOW_REWARDS_WORK[slug];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Title */ .u.Title, {
                children: "How Rewards Work"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Content */ .u.Content, {
                children: REWARDS_TERMS_CONTENT && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(REWARDS_TERMS_CONTENT, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Footer */ .u.Footer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal.Cancel */ .u.Cancel, {
                    children: "Close"
                })
            })
        ]
    });
}


/***/ }),

/***/ 84899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25167);


var PrimaryButton = function(param) {
    var children = param.children, theme = param.theme, type = param.type, submitting = param.submitting, handleClick = param.handleClick, minWidth = param.minWidth, disabled = param.disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_uielements_primaryButton_styles__WEBPACK_IMPORTED_MODULE_1__/* .StyledPrimaryButton */ .D, {
        buttonTheme: theme,
        type: type,
        submitting: submitting,
        minWidth: minWidth,
        onClick: handleClick,
        disabled: disabled,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrimaryButton);


/***/ }),

/***/ 64316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ ReorderList; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/reorders/list/styles.ts
var styles = __webpack_require__(74257);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/reorders/listItem/styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  list-style-type: none;\n  min-width: 265px;\n  padding: var(--size-3);\n  scroll-snap-align: start;\n  width: auto;\n\n  @media (min-width: 768px) {\n    margin: 0;\n    width: 33.3333%;\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-size: 13px;\n  margin: var(--size-2) 0 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin: var(--size-3) 0 0;\n\n  p {\n    margin: 0;\n\n    @supports (-webkit-line-clamp: 2) {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: var(--size-3) 0 0;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var StyledReorderListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-291919f0-0"
})(_templateObject(), function(props) {
    return props.theme.global.primary_border_color;
}, function(props) {
    return props.theme.global.border_radius;
}, function(props) {
    return props.theme.location_card.background_color;
});
var ReorderHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-291919f0-1"
})(_templateObject1());
var StyledReorderDate = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-291919f0-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        margin: 0
    }, (0,utils/* getFontStyles */.l)(theme.location_card.secondary_font, [
        "color",
        "font_size"
    ]));
});
var StyledReorderConveyanceLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-291919f0-3"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        backgroundColor: theme.buttons.primary_button_background_color,
        borderRadius: "".concat(theme.buttons.primary_button_border_radius, "px"),
        fontSize: "12px",
        padding: "var(--size-1) var(--size-2)",
        whiteSpace: "nowrap"
    }, (0,utils/* getFontStyles */.l)(theme.buttons.primary_font, [
        "font_family",
        "font_weight",
        "color"
    ], {
        color: function(value) {
            if (value === "revert" || value === null) {
                return (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.primary_button_background_color);
            }
            return value;
        }
    }));
});
var StyledReorderLocationLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-291919f0-4"
})(_templateObject2());
var StyledReorderMenuItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-291919f0-5"
})(_templateObject3());
var StyledReorderButton = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-291919f0-6"
})(_templateObject4());

// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/constants/global.ts
var global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/utils/basket.ts
var basket = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/components/reorders/listItem/index.tsx








var ReorderListItem = function(param) {
    var orderDetails = param.orderDetails, showReorderReceipt = param.showReorderReceipt;
    var ref;
    var orderConveyance = global/* API_FOR_CONVEYANCE_TYPES_SWAP */.NX[orderDetails.order_data.basket.conveyance_type.type] || dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderListItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReorderHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderDate, {
                        children: (0,utils_dates/* formatDate */.p6)(orderDetails.order_data.order.ordered_at, dates/* DATE_FORMAT.SHORT_WRITTEN_DATE */.z.SHORT_WRITTEN_DATE)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderConveyanceLabel, {
                        children: orderConveyance
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderLocationLabel, {
                children: (ref = orderDetails.store_location) === null || ref === void 0 ? void 0 : ref.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderMenuItems, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: (0,basket/* deriveBasketItemsList */.Mf)(orderDetails.order_data.basket.basket_items)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderButton, {
                buttonTheme: "primary",
                submitting: false,
                onClick: function() {
                    showReorderReceipt(orderDetails);
                },
                "aria-label": "Reorder order #".concat(orderDetails.order_data.order.order_number),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "reorders.reorder_cta"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/reorders/viewAll/styles.ts


function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  flex-grow: var(--reorder-view-all-container__flex-grow);\n  margin: 0 0 0 auto;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledReorderViewAllContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91a2ddc1-0"
})(styles_templateObject(), function(props) {
    return "\n    --reorder-view-all-container__flex-grow: ".concat(props.expand ? "1" : "auto", ";\n  ");
});
var StyledReorderViewAll = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-91a2ddc1-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        textDecoration: "underline"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ]));
});

// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
;// CONCATENATED MODULE: ./src/components/reorders/viewAll/index.tsx





var ViewAllReordersLink = function(props) {
    var expand = props.expand;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderViewAllContainer, {
        expand: expand,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderViewAll, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "reorders.view_all_past_orders_cta"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/historyIcon/index.tsx


var _HistoryIconSvg = function(param) {
    var color = param.color, _size = param.size, size = _size === void 0 ? 24 : _size, theme = param.theme;
    var _color;
    var fallbackColor = (_color = theme.text.primary_font.color) !== null && _color !== void 0 ? _color : "inherit";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.925 2.843a9.096 9.096 0 0 0-8.769 6.845l-.609-.921a.832.832 0 1 0-1.389.915l1.832 2.776a.902.902 0 0 0 .528.354c.217.043.443 0 .629-.121l2.747-1.85a.832.832 0 1 0-.928-1.382l-1.25.843a7.416 7.416 0 1 1 7.21 9.19 7.402 7.402 0 0 1-6.062-3.182.833.833 0 1 0-1.365.952A9.058 9.058 0 0 0 22 12a9.127 9.127 0 0 0-9.073-9.157Z",
                fill: color !== null && color !== void 0 ? color : fallbackColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.842 6.963a.833.833 0 0 0-.832.833V12c.003.22.09.43.244.588l2.497 2.52a.844.844 0 0 0 1.177.006.832.832 0 0 0 .005-1.177l-2.258-2.28V7.797a.833.833 0 0 0-.833-.833Z",
                fill: color !== null && color !== void 0 ? color : fallbackColor
            })
        ]
    });
};
var HistoryIconSvg = (0,styled_components_browser_esm/* withTheme */.Zz)(_HistoryIconSvg);

// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/utils/orders.ts
var orders = __webpack_require__(40274);
;// CONCATENATED MODULE: ./src/components/reorders/list/index.tsx











var ReorderList = function(param) {
    var locationID = param.locationID, _ordersToDisplay = param.ordersToDisplay, ordersToDisplay = _ordersToDisplay === void 0 ? 3 : _ordersToDisplay, _collapsible = param.collapsible, collapsible = _collapsible === void 0 ? true : _collapsible, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    var pastOrders = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.pastOrders;
    });
    var orderCompleted = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket.orderCompleted;
    });
    var dispatch = (0,redux/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), listCollapse = ref[0], setListCollapse = ref[1];
    var reorderListRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (orderCompleted) {
            dispatch(actions/* default.fetchMePastOrders */.Z.fetchMePastOrders());
        }
    }, [
        orderCompleted
    ]);
    /**
   * Hydrate the reorder modal details and toggle the reorder modal open
   *
   * @param orderDetails OrderDetails
   */ var hydrateAndToggleReorderModal = function(orderDetails) {
        dispatch(actions/* default.fetchMeOrderDetailsSuccess */.Z.fetchMeOrderDetailsSuccess(orderDetails));
        dispatch(actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(true));
    };
    /**
   * Handle the collapse chevron button click
   */ var handleCollapseClick = function() {
        setListCollapse(!listCollapse);
    };
    var reorders = (0,orders/* deriveOrdersByLocationID */.WJ)(pastOrders, locationID).slice(0, ordersToDisplay);
    // Triple check we have reorders to display before showing the reorder interface
    // (This is applicable in scenarios where a user has past orders but none for a specific store)
    if (!reorders.length) {
        return null;
    }
    var ariaControlsID = "recent-orders";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: reorderListRef,
        className: "koala__ui-reorders-container-div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                overrides: {
                    margin: "var(--size-4) 0"
                },
                children: [
                    showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryIconSvg, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: styles/* StyledReorderHeading */.rS,
                        accessor: "reorders.recent_orders_title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewAllReordersLink, {
                        expand: collapsible
                    }),
                    collapsible && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledCollapseButton */.SR, {
                        onClick: function() {
                            return handleCollapseClick();
                        },
                        invert: listCollapse,
                        "aria-expanded": !listCollapse,
                        "aria-controls": ariaControlsID,
                        id: "controls-".concat(ariaControlsID)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledCollapsibleContainer */.xd, {
                collapse: listCollapse,
                role: "region",
                tabIndex: -1,
                id: ariaControlsID,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledReorderList */.ck, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ReorderListPadding */.b$, {}),
                        reorders.map(function(order, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderListItem, {
                                orderDetails: order,
                                showReorderReceipt: hydrateAndToggleReorderModal
                            }, "".concat(order.id, "-").concat(i));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ReorderListPadding */.b$, {})
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 74257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SR": function() { return /* binding */ StyledCollapseButton; },
/* harmony export */   "b$": function() { return /* binding */ ReorderListPadding; },
/* harmony export */   "ck": function() { return /* binding */ StyledReorderList; },
/* harmony export */   "rS": function() { return /* binding */ StyledReorderHeading; },
/* harmony export */   "xd": function() { return /* binding */ StyledCollapsibleContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 300px;\n  transition: max-height ",
        " ease-in-out, visibility 0s 0s;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: var(--size-2);\n  margin: 0 var(--neg-size-5) 0 var(--neg-size-5);\n  padding: 0;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n    display: none;\n    height: 0;\n    width: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: var(--size-1);\n  position: relative;\n\n  &::after {\n    content: "";\n    display: block;\n    position: relative;\n    height: ',
        "px;\n    border-bottom: 1.5px solid\n      ",
        ";\n    border-right: 1.5px solid\n      ",
        ";\n    transform: rotate(225deg) translateX(-25%) translateY(-25%);\n    transition: transform ",
        " ease-in-out;\n    width: ",
        "px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 0 0 var(--size-3);\n  height: var(--size-5);\n  scroll-snap-align: start;\n  list-style-type: none;\n  width: var(--size-3);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var LIST_TRANSITION_TIME = "0.35s";
var StyledCollapsibleContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68e04783-0"
})(_templateObject(), LIST_TRANSITION_TIME, function(props) {
    return props.collapse && "\n    max-height: 0px;\n    visibility: hidden;\n    transition: max-height ".concat(LIST_TRANSITION_TIME, " ease-in-out, visibility 0s ").concat(LIST_TRANSITION_TIME, ";\n  ");
});
var StyledReorderList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-68e04783-1"
})(_templateObject1());
var StyledReorderHeading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-68e04783-2"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        margin: 0
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.location_search.tertiary_font, [
        "color",
        "font_family",
        "font_size", 
    ]));
});
var StyledCollapseButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-68e04783-3"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.XS */ .jl.XS, function(props) {
    return props.theme.global.primary_active_color;
}, function(props) {
    return props.theme.global.primary_active_color;
}, LIST_TRANSITION_TIME, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.XS */ .jl.XS, function(props) {
    return props.invert && "\n      transform: rotate(45deg);\n    ";
});
var ReorderListPadding = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-68e04783-4"
})(_templateObject3());


/***/ }),

/***/ 62355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ animatedBlock; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/uielements/animatedBlock/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  overflow: hidden;\n  @keyframes barberpolebackground {\n    from {\n      background-position: 0 0;\n    }\n    to {\n      background-position: 101px 0;\n    }\n  }\n\n  &:after {\n    height: 100%;\n    width: 2050px;\n    bottom: 0;\n    content: "";\n    left: 0;\n    opacity: 0.3;\n    position: absolute;\n    right: 0;\n    top: 0;\n\n    transition: opacity 0.3s ease;\n    background: repeating-linear-gradient(\n      -55deg,\n      ',
        " 1px,\n      ",
        " 2px,\n      ",
        " 11px,\n      ",
        " 12px,\n      ",
        " 22px\n    );\n\n    animation-name: barberpolebackground;\n    animation-duration: 2s;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledAnimatedBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d05edf98-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.loading_bar_color;
}, styles/* COLORS.PRIMARY_NAVY_XX_LIGHT */.DM.PRIMARY_NAVY_XX_LIGHT, styles/* COLORS.PRIMARY_NAVY_XX_LIGHT */.DM.PRIMARY_NAVY_XX_LIGHT, function(param) {
    var theme = param.theme;
    return theme.global.loading_bar_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.loading_bar_color;
});

;// CONCATENATED MODULE: ./src/components/uielements/animatedBlock/index.tsx







var AnimatedBlockComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AnimatedBlockComponent, Component);
    var _super = (0,_create_super/* default */.Z)(AnimatedBlockComponent);
    function AnimatedBlockComponent() {
        (0,_class_call_check/* default */.Z)(this, AnimatedBlockComponent);
        return _super.apply(this, arguments);
    }
    var _proto = AnimatedBlockComponent.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnimatedBlock, (0,_object_spread/* default */.Z)({}, this.props));
    };
    return AnimatedBlockComponent;
}(react.Component);
/* harmony default export */ var animatedBlock = (AnimatedBlockComponent);


/***/ }),

/***/ 51912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ StyledHr; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  display: block;\n  height: 1px;\n  border: 0;\n  margin: ",
        "px 0;\n  padding: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledHr = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-d8fdad27-0"
})(_templateObject(), function(param) {
    var background = param.background, theme = param.theme;
    return background || theme.global.primary_border_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.MEDIUM */ .jl.MEDIUM);


/***/ }),

/***/ 17187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ finder; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(38726);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ./src/components/account/uielements/index.tsx + 1 modules
var uielements = __webpack_require__(9671);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/account/locationRewardsSummary/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        "px;\n  padding: ",
        "px;\n  display: flex;\n  align-items: center;\n\n  div {\n    margin: 0;\n  }\n\n  svg,\n  img {\n    height: 56px;\n    width: 56px;\n    margin-right: ",
        "px;\n    min-width: 10%;\n\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-start;\n  line-height: 1.5;\n  margin: 0;\n\n  button,\n  a {\n    text-align: left;\n    font-size: 14px;\n    margin: ",
        "px 0 0 0;\n    color: ",
        ";\n\n    // If contrast is not high enough\n    ",
        ";\n\n    &:nth-of-type(even) {\n      margin-left: ",
        "px;\n    }\n\n    &:nth-of-type(odd) {\n      margin-right: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledLocationsRewardsSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4b41d97-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)("0.9", theme.global.primary_active_color);
}, function(param) {
    var theme = param.theme;
    return theme.global.border_radius;
}, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledRewardsSummaryHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-b4b41d97-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});
var _color;
var StyledButtonContainer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-b4b41d97-2"
})(_templateObject2(), styles/* LAYOUT.GUTTER */._.GUTTER / 4, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* getContrast */.mj)(styles/* COLORS.WHITE */.DM.WHITE, theme.global.primary_active_color) < 4.5 && "\n      color: ".concat((_color = theme.text.primary_font.color) !== null && _color !== void 0 ? _color : "inherit", ";\n      text-decoration: underline;\n    ");
}, styles/* LAYOUT.GUTTER */._.GUTTER / 2, styles/* LAYOUT.GUTTER */._.GUTTER / 2);

// EXTERNAL MODULE: ./src/brand-components/index.ts + 14 modules
var brand_components = __webpack_require__(96588);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/account/loyaltyAccessor/index.tsx
var loyaltyAccessor = __webpack_require__(51319);
// EXTERNAL MODULE: ./src/components/account/rewards/terms/index.tsx
var terms = __webpack_require__(43038);
// EXTERNAL MODULE: ./src/components/account/styles.ts
var account_styles = __webpack_require__(99736);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/uielements/modal/index.tsx + 9 modules
var modal = __webpack_require__(84247);
// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/constants/loyalty.ts
var loyalty = __webpack_require__(92106);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/components/account/locationRewardsSummary/buttons/index.tsx













var RewardsSummaryButtons = function(param) {
    var showRewardsTerms = param.showRewardsTerms;
    var strings = (0,es.useSelector)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var me = (0,es.useSelector)(function(state) {
        return state.app.me.data;
    });
    var howRewardsWorkExternalURL = (0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.learn_more_url");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonContainer, {
        children: !(me === null || me === void 0 ? void 0 : me.id) ? // If not logged in
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: routes/* ROUTES.SIGN_UP */.Z6.SIGN_UP,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                        bold: true,
                        as: "a",
                        className: cssClassNames/* CSS_CLASSES.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK */.Y.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "locations.loyalty_module_signed_out_join_cta"
                        })
                    })
                }),
                howRewardsWorkExternalURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                    bold: true,
                    className: cssClassNames/* CSS_CLASSES.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK */.Y.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK,
                    as: "a",
                    href: howRewardsWorkExternalURL,
                    target: "_blank",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "locations.loyalty_module_signed_out_learn_cta"
                    })
                }),
                showRewardsTerms && !howRewardsWorkExternalURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Container */.u.Container, {
                    trigger: function(open) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                            bold: true,
                            onClick: open,
                            className: cssClassNames/* CSS_CLASSES.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK */.Y.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                accessor: "locations.loyalty_module_signed_out_learn_cta"
                            })
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms/* Terms */.F, {})
                })
            ]
        }) : // Only show link if logged in and brand supports a Rewards Page
        /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
            checkType: loyalty/* LOYALTY_ACCESSOR_TYPES.ROUTE */.Mo.ROUTE,
            checkName: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_styles/* StyledLinkButton */.UN, {
                    bold: true,
                    as: "a",
                    className: cssClassNames/* CSS_CLASSES.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK */.Y.LOYALTY.LOCATIONS_REWARDS_SUMMARY_LINK,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        accessor: "locations.loyalty_module_signed_in_cta"
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/account/locationRewardsSummary/header/index.tsx





var rewardsSummaryStringHandler = function(me, loyaltyState, strings) {
    // If not logged in
    if (!(me === null || me === void 0 ? void 0 : me.id)) {
        return {
            accessor: "locations.loyalty_module_signed_out_header",
            dataObj: null
        };
    }
    // If user has loyalty points
    if (loyaltyState === null || loyaltyState === void 0 ? void 0 : loyaltyState.points) {
        var pointsCounter = (0,stringHelpers/* pluralizeString */.fB)((0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.rewards_counter"), loyaltyState.points > 1);
        return {
            accessor: "locations.loyalty_module_signed_in_header",
            dataObj: {
                points: loyaltyState.points.toLocaleString(),
                counter: pointsCounter
            }
        };
    }
    // Logged in but no points
    return {
        accessor: "locations.loyalty_module_signed_in_header_no_points",
        dataObj: null
    };
};
var _RewardsSummaryHeader = function(param) {
    var me = param.me, loyaltyState = param.loyaltyState, strings = param.strings;
    var ref = rewardsSummaryStringHandler(me, loyaltyState, strings), accessor = ref.accessor, dataObj = ref.dataObj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRewardsSummaryHeader, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
            accessor: accessor,
            html: true,
            dataObj: dataObj
        })
    });
};
var mapStateToProps = function(state) {
    return {
        me: state.app.me.data,
        loyaltyState: state.app.me.loyaltyState,
        strings: state.app.cmsConfig.strings
    };
};
var connector = (0,es.connect)(mapStateToProps);
var RewardsSummaryHeader = connector(_RewardsSummaryHeader);

// EXTERNAL MODULE: ./src/redux/index.ts
var src_redux = __webpack_require__(86879);
;// CONCATENATED MODULE: ./src/components/account/locationRewardsSummary/index.tsx








function LocationsRewardsSummary() {
    var slug = (0,src_redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).slug;
    var REWARDS_TERMS_CONTENT = brand_components/* COMPONENT_CONFIG.MODAL_HOW_REWARDS_WORK */.P.MODAL_HOW_REWARDS_WORK[slug];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocationsRewardsSummary, {
            className: cssClassNames/* CSS_CLASSES.LOYALTY.LOCATIONS_REWARDS_SUMMARY */.Y.LOYALTY.LOCATIONS_REWARDS_SUMMARY,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedRewardsIcon */.Cu, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardsSummaryHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RewardsSummaryButtons, {
                            showRewardsTerms: REWARDS_TERMS_CONTENT
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/app/fixOnScroll/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FixedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-11e50c3-0"
})(styles_templateObject(), function(props) {
    return props.fixed && "\n    left: 0;\n    position: fixed;\n    top: ".concat(props.fromTop, "px;\n    width: 100%;\n    z-index: 1;\n  ");
});

;// CONCATENATED MODULE: ./src/components/app/fixOnScroll/index.tsx






var FixOnScroll = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FixOnScroll, Component);
    var _super = (0,_create_super/* default */.Z)(FixOnScroll);
    function FixOnScroll() {
        (0,_class_call_check/* default */.Z)(this, FixOnScroll);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            elementHeight: null,
            fixed: false
        };
        _this.handleScroll = function() {
            // Get 'fixed' element in order to derive height
            var element = document.getElementById(_this.props.id);
            // Get 'fixed' elements' static container to derive position from top
            var elementContainer = document.getElementById("".concat(_this.props.id, "Container"));
            if (element && elementContainer) {
                var elementHeight = element.offsetHeight;
                var pos = elementContainer.getBoundingClientRect();
                var fixed = (_this.props.minWidth || 9999) >= window.innerWidth && pos.top < _this.props.fromTop;
                _this.setState({
                    elementHeight: elementHeight,
                    fixed: fixed
                });
            }
        };
        return _this;
    }
    var _proto = FixOnScroll.prototype;
    _proto.componentDidMount = function componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, fromTop = _props.fromTop, id = _props.id;
        var _state = this.state, fixed = _state.fixed, elementHeight = _state.elementHeight;
        // Attach fixed status to child component
        var childrenWithProps = react.Children.map(children, function(child) {
            return /*#__PURE__*/ (0,react.cloneElement)(child, {
                fixed: fixed
            });
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "".concat(id, "Container"),
            style: {
                height: fixed && elementHeight || "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedContainer, {
                fromTop: fromTop,
                fixed: fixed,
                id: id,
                children: childrenWithProps
            })
        });
    };
    return FixOnScroll;
}(react.Component);


// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/featureAccessor/index.tsx
var featureAccessor = __webpack_require__(88917);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/components/uielements/label/index.tsx
var label = __webpack_require__(34404);
// EXTERNAL MODULE: ./src/constants/locations.ts
var constants_locations = __webpack_require__(56296);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/redux/locations/actions.ts
var actions = __webpack_require__(17464);
;// CONCATENATED MODULE: ./src/components/locations/heading/index.tsx










var _LocationsHeading = function(props) {
    var locationViewState = props.locationViewState, theme = props.theme;
    var listDisplay = theme.locations.list_display;
    var toggleSearchRadius = function(currentParams) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                    visuallyHidden: true,
                    htmlFor: "search-radius",
                    children: "Select location radius to search by"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRadiusSelect, {
                    id: "search-radius",
                    name: "search-radius",
                    onChange: function(e) {
                        return props.onSearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentParams), {
                            distance: e.target.value
                        }), actions/* locationActionTypes.SEARCH_LOCATIONS */.N.SEARCH_LOCATIONS);
                    },
                    value: currentParams.distance,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 1,
                            children: "1 mile"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 5,
                            children: "5 miles"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 10,
                            children: "10 miles"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 15,
                            children: "15 miles"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 20,
                            children: "20 miles"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: 25,
                            children: "25 miles"
                        })
                    ]
                })
            ]
        });
    };
    var deriveResults = function() {
        var locations = props.locations, locationParams = props.locationParams, locationsMeta = props.locationsMeta, isLoading = props.isLoading, clickedMapSearch = props.clickedMapSearch;
        var SEARCH_HEADING = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Showing ",
                locations ? locations.length : "",
                " locations within",
                " ",
                locationParams ? toggleSearchRadius(locationParams) : "",
                " of",
                " ",
                locationParams && locationParams.address ? decodeURIComponent(locationParams.address) : "your location",
                ":"
            ]
        });
        var ALL_HEADING = locations && locations.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Showing ",
                locations && locations.length,
                " of",
                " ",
                get_default()(locationsMeta, "pagination.total"),
                " locations:"
            ]
        }) : null;
        var MAP_SEARCH_HEADING = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Showing ",
                locations && locations.length,
                " locations within your search area:"
            ]
        });
        var locationsHeading = ALL_HEADING;
        if (!isLoading) {
            if (locations && locations.length && locationParams && !clickedMapSearch) {
                locationsHeading = SEARCH_HEADING;
            } else if (clickedMapSearch) {
                locationsHeading = MAP_SEARCH_HEADING;
            }
        }
        return locationsHeading;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (listDisplay !== constants_locations/* LOCATIONS_CONFIG.ALL_DISPLAY.GROUP_BY_STATE */.u.ALL_DISPLAY.GROUP_BY_STATE || locationViewState !== constants_locations/* LOCATION_VIEW_STATES.VIEW_ALL */.w6.VIEW_ALL) && deriveResults() && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchHeading, {
            className: cssClassNames/* CSS_CLASSES.STORE_LOCATOR.SEARCH_HEADING */.Y.STORE_LOCATOR.SEARCH_HEADING,
            children: deriveResults()
        })
    });
};
var StyledSearchHeading = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-d77b8660-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "font_size"
    ])), {
        lineHeight: 1,
        margin: "20px 0"
    });
});
var _background_color, _border_color, _border_radius;
var StyledRadiusSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-d77b8660-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        backgroundColor: (_background_color = theme.forms.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid ".concat((_border_color = theme.forms.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.forms.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px")
    }, (0,utils/* getFontStyles */.l)(theme.forms.font, [
        "color"
    ]));
});
var LocationsHeading = (0,styled_components_browser_esm/* withTheme */.Zz)(_LocationsHeading);

// EXTERNAL MODULE: ./src/components/uielements/animatedBlock/index.tsx + 1 modules
var animatedBlock = __webpack_require__(62355);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
;// CONCATENATED MODULE: ./src/components/locations/layout/styles.tsx



function layout_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  background: ",
        ";\n  border-radius: 5px;\n  font-size: 16px;\n  color: white;\n  padding: 12px ",
        "px;\n  z-index: ",
        ";\n  .small {\n    font-size: 12px;\n    padding: 3px;\n  }\n  .pad {\n    margin-bottom: 20px;\n  }\n"
    ]);
    layout_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  min-height: 100vh;\n  position: relative;\n\n  @media (max-width: 767px) {\n    display: block;\n    position: static;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  > div {\n    > h3 {\n      color: rgba(48, 62, 71, 0.5);\n      font-family: ",
        ";\n      font-size: 12px;\n      margin: 30px 0 20px;\n    }\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  width: calc(100% - 500px);\n  z-index: ",
        ";\n\n  // Determine map position\n  ",
        ";\n\n  @media (max-width: 1024px) {\n    width: 50%;\n  }\n\n  @media (max-width: 767px) {\n    height: calc(\n      100vh - ",
        "px -\n        ",
        "px -\n        ",
        "px\n    );\n    opacity: 0;\n    position: fixed;\n    top: ",
        "px;\n    width: 100%;\n    z-index: -1;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  margin: ",
        "px 0 12px 0;\n\n  @media (max-width: 767px) {\n    margin-top: 25px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 ",
        "px;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  height: 52px;\n\n  // Inactive state\n  background-color: transparent;\n\n  ",
        "\n\n  @media (max-width: 767px) {\n    justify-content: center;\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px 0 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}








var LoadingIndicator = (0,styled_components_browser_esm/* default */.ZP)(animatedBlock/* default */.Z).attrs(function() {
    return {
        "data-testid": "loading-indicator"
    };
}).withConfig({
    componentId: "sc-322adf28-0"
})(layout_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.loading_bar_color;
}, styles/* LAYOUT.GUTTER */._.GUTTER, styles/* ORDER.BARBER_LOADING */.kl.BARBER_LOADING);
var LocationsLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.locations.map_position === "left" ? "row-reverse" : "row";
});
var LocationsLayoutList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-2"
})(function(param) {
    var theme = param.theme;
    return {
        padding: "40px 20px 20px",
        width: "500px",
        "> h1": (0,_object_spread/* default */.Z)({
            margin: 0
        }, (0,utils/* getFontStyles */.l)(theme.location_search.secondary_font)),
        "> div": (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
            "font_size"
        ])),
        "@media (max-width: 1024px)": {
            width: "50%"
        },
        "@media (max-width: 767px)": {
            padding: "20px 20px 0",
            width: "100%",
            "> h1": {
                marginBottom: "10px"
            }
        }
    };
});
var LayoutListSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-3"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.primary_font.bold.font_family;
});
var LocationsLayoutMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-4"
})(_templateObject3(), styles/* ORDER.MAP */.kl.MAP, function(param) {
    var theme = param.theme;
    return theme.locations.map_position === "right" ? "\n    right: 0;\n  " : "\n    left: 0;\n  ";
}, styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT, styles/* LAYOUT.MOBILE_MAP_LOCATION_CARD_HEIGHT */._.MOBILE_MAP_LOCATION_CARD_HEIGHT, styles/* LAYOUT.MOBILE_LIST_MAP_FOOTER_HEIGHT */._.MOBILE_LIST_MAP_FOOTER_HEIGHT, styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT);
var LocationsNoResults = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-5"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER);
var LocationsViewAll = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-322adf28-6"
})(_templateObject5(), styles/* LAYOUT.GUTTER */._.GUTTER);
var LocationsHandoffToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-7"
})(_templateObject6(), function(param) {
    var handoffMode = param.handoffMode, theme = param.theme;
    return "\n    border-radius: ".concat(theme.global.border_radius, "px;\n    border: 1px solid ").concat(theme.buttons.secondary_button_border_color, ";\n\n    &:after {\n      // Active state\n      box-sizing: border-box; //include border size into calculation of width and height\n      border-radius: calc(").concat(theme.global.border_radius, "px - var(--size-1)); // --size-1 is distance between button and outer div\n      border: 1px solid ").concat(theme.buttons.secondary_button_border_color, ";\n      background: ").concat(theme.buttons.secondary_button_background_color, ';\n      content: "";\n      position: absolute;\n      transition: all 0.2s linear;\n      left: var(--size-1);\n      bottom: var(--size-1);\n      height: calc(100% - var(--size-2)); // --size-2 is needed as we calculate height based on height of outer element - (bottom + top gap size)\n      width: calc(50% - var(--size-1));\n\n      ').concat(handoffMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY && "\n        left: 50%;\n      ", "\n    }\n  ");
});
var LocationsHandoffToggleButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-322adf28-8"
})(function(param) {
    var theme = param.theme, _active = param.active, active = _active === void 0 ? false : _active;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        all: "unset",
        outline: "revert",
        cursor: "pointer",
        margin: "var(--size-1)",
        textAlign: "center",
        width: "100%"
    }, (0,utils/* getFontStyles */.l)(theme.buttons.primary_font, [
        "font_family",
        "font_style",
        "font_weight",
        "line_height", 
    ])), {
        span: {
            color: active ? (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.secondary_button_background_color) : "inherit",
            position: "relative",
            zIndex: 1
        }
    });
});
//   ${({}) =>
//     `
//     ${
//       // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
//       active &&
//       `
//       span {
//       }
//     `
//     }
//   `}
// `;
var LocationsReorders = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-9"
})(function(param) {
    var theme = param.theme;
    return {
        margin: "0 0 16px",
        ".koala__ui-reorders-container-div": {
            "& > div": {
                marginBottom: 0
            }
        },
        h2: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.location_search.tertiary_font, [
            "color",
            "font_family",
            "font_size", 
        ])),
        ul: {
            overflowX: "scroll",
            margin: "var(--size-4) var(--neg-size-5) var(--size-4) var(--neg-size-5)",
            gap: "8px"
        },
        li: {
            borderRadius: "".concat(theme.location_card.border_radius, "px"),
            width: "auto"
        }
    };
});
var LocationsDeliverySearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-322adf28-10"
})(_templateObject7(), styles/* LAYOUT.GUTTER */._.GUTTER / 2);

// EXTERNAL MODULE: ./src/components/locations/card/index.tsx + 10 modules
var card = __webpack_require__(93483);
;// CONCATENATED MODULE: ./src/components/locations/results/grouped/styles.ts

function grouped_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border-top: 1px solid ",
        ";\n"
    ]);
    grouped_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function grouped_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n"
    ]);
    grouped_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function grouped_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: none;\n  color: ",
        ";\n  cursor: pointer;\n  font-family: ",
        ";\n  font-size: 20px;\n  padding: ",
        "px;\n  position: relative;\n  text-align: left;\n  width: 100%;\n\n  &:after {\n    color: ",
        ';\n    content: "›";\n    position: absolute;\n    right: ',
        "px;\n    top: calc(50% - 11px);\n    transform: rotate(\n      ",
        "deg\n    );\n  }\n"
    ], [
        "\n  background: ",
        ";\n  border: none;\n  color: ",
        ";\n  cursor: pointer;\n  font-family: ",
        ";\n  font-size: 20px;\n  padding: ",
        "px;\n  position: relative;\n  text-align: left;\n  width: 100%;\n\n  &:after {\n    color: ",
        ';\n    content: "\\u203a";\n    position: absolute;\n    right: ',
        "px;\n    top: calc(50% - 11px);\n    transform: rotate(\n      ",
        "deg\n    );\n  }\n"
    ]);
    grouped_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledLocationGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189a96ab-0"
})(grouped_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.global.primary_border_color;
});
var StyledLocationGroupHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-189a96ab-1"
})(grouped_styles_templateObject1());
var StyledLocationGroupTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-189a96ab-2"
})(grouped_styles_templateObject2(), function(props) {
    return props.isActive ? "none" : "none";
}, function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? theme.global.primary_active_color : theme.text.secondary_font.color;
}, function(param) {
    var theme = param.theme;
    return theme.primary_font.medium.font_family;
}, styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? theme.global.primary_active_color : theme.text.secondary_font.color;
}, styles/* LAYOUT.GUTTER */._.GUTTER, function(props) {
    return props.isActive ? "-90" : "90";
});
var StyledLocationGroupLocations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-189a96ab-3"
})(styles_templateObject3());

// EXTERNAL MODULE: ./src/constants/states.ts
var states = __webpack_require__(49956);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/locations.ts + 2 modules
var utils_locations = __webpack_require__(52591);
;// CONCATENATED MODULE: ./src/components/locations/results/grouped/index.tsx







/**
 * Renders a brand's locations grouped by US State or CA Province.
 *
 * @TODO change genericGroupItemsByKey to a Map lookup to reduce o^n complexity.
 * @TODO consume `setActiveLocation` at the `LocationCard` level to eliminate
 * prop drilling.
 * @TODO DRY out card rendering per-country.
 */ function GroupedLocationList(param) {
    var locations = param.locations, setActiveLocation = param.setActiveLocation, activeLocationId = param.activeLocationId, menuCta = param.menuCta;
    var toggleActiveGroup = // Expands or collapses a group of locations in the list.
    function toggleActiveGroup(selectedGroupName) {
        setExpandedGroupId(function(currentGroupName) {
            // If the clicked group is currently expanded, collapse it.
            if (selectedGroupName === currentGroupName) {
                return null;
            }
            // Otherwise, expand the new group.
            return selectedGroupName;
        });
    };
    var ref = (0,react.useState)(null), expandedGroupName = ref[0], setExpandedGroupId = ref[1];
    // Split locations by country—Canada or USA.
    var locationsByCountry = (0,utils_locations/* splitLocationsByCountry */.I9)(locations);
    // Group US locations by state and sort alphabetically.
    var ref1 = (0,global/* genericGroupItemsByKey */.sW)(locationsByCountry.US, "cached_data.state"), statesArray = ref1.filtersArray, statesObject = ref1.filtersObject;
    // Group US locations by province and sort alphabetically.
    var ref2 = (0,global/* genericGroupItemsByKey */.sW)(locationsByCountry.CA, "cached_data.state"), provincesArray = ref2.filtersArray, provincesObject = ref2.filtersObject;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            statesArray.map(function(state, stateIndex) {
                // The group of locations is uniquely identified by the state name.
                // @ts-expect-error `state` string can't index `stateAbbrMappings`.
                var stateName = states/* stateAbbrMappings */.S[state];
                var isExpanded = stateName === expandedGroupName;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocationGroup, {
                    "aria-label": "".concat(stateName, " locations"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationGroupHeading, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationGroupTrigger, {
                                isActive: isExpanded,
                                onClick: function() {
                                    return toggleActiveGroup(stateName);
                                },
                                "aria-expanded": isExpanded,
                                children: stateName
                            })
                        }),
                        isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationGroupLocations, {
                            children: statesObject[state].map(function(location) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* LocationCard */.b, {
                                    activeLocationId: activeLocationId,
                                    location: location,
                                    setActiveLocation: setActiveLocation,
                                    menuCta: menuCta
                                }, location.id);
                            })
                        })
                    ]
                }, stateIndex);
            }),
            provincesArray.map(function(state) {
                // The group of locations is uniquely identified by the province name.
                // @ts-expect-error `state` string can't index `canadianProvinceAbbrMappings`.
                var provinceName = states/* canadianProvinceAbbrMappings */.E[state];
                var isExpanded = provinceName === expandedGroupName;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocationGroup, {
                    "aria-label": "".concat(provinceName, " locations"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationGroupHeading, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationGroupTrigger, {
                                isActive: isExpanded,
                                onClick: function() {
                                    return toggleActiveGroup(provinceName);
                                },
                                "aria-expanded": isExpanded,
                                children: provinceName
                            })
                        }),
                        isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationGroupLocations, {
                            children: provincesObject[state].map(function(location) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* LocationCard */.b, {
                                    activeLocationId: activeLocationId,
                                    location: location,
                                    setActiveLocation: setActiveLocation,
                                    menuCta: menuCta
                                }, location.id);
                            })
                        })
                    ]
                }, provinceName);
            })
        ]
    });
}
/* harmony default export */ var grouped = (GroupedLocationList);

;// CONCATENATED MODULE: ./src/components/locations/results/list/index.tsx






var List = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(List, _Component);
    var _super = (0,_create_super/* default */.Z)(List);
    function List() {
        (0,_class_call_check/* default */.Z)(this, List);
        return _super.apply(this, arguments);
    }
    var _proto = List.prototype;
    _proto.render = function render() {
        var _props = this.props, locations = _props.locations, setActiveLocation = _props.setActiveLocation, activeLocationId = _props.activeLocationId, menuCta = _props.menuCta;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: locations && locations.length > 0 && locations.map(function(location) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* LocationCard */.b, {
                    activeLocationId: activeLocationId,
                    location: location,
                    setActiveLocation: setActiveLocation,
                    menuCta: menuCta
                }, location.id);
            })
        });
    };
    return List;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/locations/results/index.tsx










var LocationResults = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LocationResults, Component);
    var _super = (0,_create_super/* default */.Z)(LocationResults);
    function LocationResults() {
        (0,_class_call_check/* default */.Z)(this, LocationResults);
        return _super.apply(this, arguments);
    }
    var _proto = LocationResults.prototype;
    _proto.render = function render() {
        var _props = this.props, activeLocationId = _props.activeLocationId, displayType = _props.displayType, locations = _props.locations, setActiveLocation = _props.setActiveLocation, menuCta = _props.menuCta, webConfig = _props.webConfig;
        var listDisplay = (0,stringHelpers/* safelyGetConfig */.K6)(webConfig, "locations.list_display");
        /*
      A 'grouped' results list should only display if a) the config has enabled it and b) we are in 'view_all' mode.
      Otherwise, we should display a normal list
    */ if (listDisplay === constants_locations/* LOCATIONS_CONFIG.ALL_DISPLAY.GROUP_BY_STATE */.u.ALL_DISPLAY.GROUP_BY_STATE && displayType === constants_locations/* LOCATION_VIEW_STATES.VIEW_ALL */.w6.VIEW_ALL) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(grouped, {
                activeLocationId: activeLocationId,
                locations: locations,
                setActiveLocation: setActiveLocation,
                menuCta: menuCta
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
            activeLocationId: activeLocationId,
            locations: locations,
            setActiveLocation: setActiveLocation,
            menuCta: menuCta
        });
    };
    return LocationResults;
}(react.Component);
var results_mapStateToProps = function(state) {
    return {
        webConfig: state.app.cmsConfig.webConfig
    };
};
var results_connector = (0,es.connect)(results_mapStateToProps);
/* harmony default export */ var results = (results_connector(LocationResults));

// EXTERNAL MODULE: ../../node_modules/redux-form/es/Field.js + 10 modules
var Field = __webpack_require__(82415);
// EXTERNAL MODULE: ../../node_modules/redux-form/es/reduxForm.js + 15 modules
var reduxForm = __webpack_require__(45900);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/utils.ts
var primaryButton_utils = __webpack_require__(30694);
;// CONCATENATED MODULE: ./src/components/locations/search/styles.tsx


function search_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px 0 0;\n\n  ",
        "\n"
    ]);
    search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n\n  > div {\n    position: relative;\n    flex-basis: 70%;\n  }\n"
    ]);
    search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-basis: 30%;\n  margin-left: ",
        "px;\n\n  @media (max-width: 767px) {\n    border-radius: ",
        ";\n    margin-left: 0px;\n  }\n"
    ]);
    search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  height: 40px;\n  padding: 0 7px 0 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  img {\n    height: 20px;\n  }\n"
    ]);
    search_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin: ",
        "px 0;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var StyledSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97cecbe3-0"
})(search_styles_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(param) {
    var fixed = param.fixed, theme = param.theme;
    return fixed && "\n    background: ".concat(theme.global.body_color, ";\n    border-bottom: 1px solid ").concat(theme.global.primary_border_color, ";\n    padding-left: ").concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px;\n    padding-right: ").concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px;\n  ");
});
var StyledForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-97cecbe3-1"
})(search_styles_templateObject1());
var StyledSubmit = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-97cecbe3-2"
})(search_styles_templateObject2(), styles/* LAYOUT.GUTTER */._.GUTTER / 2, function(param) {
    var theme = param.theme;
    return "0 ".concat(theme.buttons.primary_button_border_radius, "px ").concat(theme.buttons.primary_button_border_radius, "px 0");
});
var StyledLocationIcon = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-97cecbe3-3"
})(search_styles_templateObject3());
var StyledViewAllWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97cecbe3-4"
})(styles_templateObject4(), styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledViewAll = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-97cecbe3-5"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        background: theme.buttons.knockout_button_background_color,
        color: theme.buttons.knockout_button_text_color,
        cursor: "pointer",
        fontFamily: theme.primary_font.medium.font_family,
        padding: "0 ".concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px"),
        height: theme.forms.field_height,
        minWidth: "100px"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ]), (0,primaryButton_utils/* getButtonThemeProperties */.jo)("knockout", theme));
});
var StyledFindOrgStoreText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-97cecbe3-6"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        justifyContent: "center",
        fontFamily: theme.primary_font.bold.font_family,
        fontWeight: theme.primary_font.bold.font_weight,
        fontSize: theme.primary_font.bold.font_size
    };
});
var StyledOrUseLocationText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-97cecbe3-7"
})(function(param) {
    var theme = param.theme;
    return {
        "::after": {
            content: "'\0a0\0a0\0a0\0a0\0a0'",
            textDecoration: "line-through"
        },
        "::before": {
            content: "'\0a0\0a0\0a0\0a0\0a0'",
            textDecoration: "line-through"
        },
        color: "#4a4a4a",
        display: "flex",
        justifyContent: "center",
        fontFamily: theme.primary_font.medium.font_family,
        fontWeight: theme.primary_font.medium.font_weight,
        fontSize: theme.primary_font.medium.font_size
    };
});
var StyledUseMyCurrentLocation = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-97cecbe3-8"
})(function(param) {
    var theme = param.theme;
    return {
        a: {
            display: "flex",
            justifyContent: "center",
            color: theme.global.primary_active_color,
            cursor: "pointer",
            fontFamily: theme.primary_font.bold.font_family,
            fontWeight: theme.primary_font.bold.font_weight,
            fontSize: theme.primary_font.bold.font_size
        }
    };
});

// EXTERNAL MODULE: ./src/components/uielements/searchInput/index.tsx
var searchInput = __webpack_require__(66143);
// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
;// CONCATENATED MODULE: ./src/utils/geolocate.ts
function getUserLocation() {
    return new Promise(function(resolve, reject) {
        var position = function position(location) {
            resolve(location.coords);
        };
        var denied = function denied(errorObj) {
            var msg = "The Geolocation service failed. Please try manually searching instead.";
            if (errorObj.code === 1) {
                msg = "You have blocked location services on this browser.";
            }
            reject(msg);
        };
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position, denied);
        }
    });
}

// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
// EXTERNAL MODULE: ./src/components/uielements/hr/index.ts
var hr = __webpack_require__(51912);
;// CONCATENATED MODULE: ./src/components/locations/search/index.tsx





















var Search = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Search, Component);
    var _super = (0,_create_super/* default */.Z)(Search);
    function Search() {
        (0,_class_call_check/* default */.Z)(this, Search);
        var _this;
        _this = _super.apply(this, arguments);
        _this.getUserLocation = function() {
            var _props = _this.props, onSearch = _props.onSearch, isGeoIpEnabled = _props.isGeoIpEnabled;
            // TODO - this should be move into REDUX so we can use the loading state
            getUserLocation().then(function(param) {
                var latitude = param.latitude, longitude = param.longitude;
                onSearch({
                    distance: constants_locations/* LOCATION_OPTIONS.defaultSearchRadius */.pr.defaultSearchRadius,
                    latitude: latitude,
                    longitude: longitude
                });
                // KA Event for explicit geolocation searches only
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.GEOLOCATION_SEARCH */.AH.GEOLOCATION_SEARCH, {
                    name: "".concat(latitude, ", ").concat(longitude)
                });
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.findShop */.m1.findShop, googleAnalytics/* gaActions.geolocationSearch */.cE.geolocationSearch);
            }).catch(function() {
                if (isGeoIpEnabled) {
                    _this.props.getNearbyLocations();
                }
            });
        };
        return _this;
    }
    var _proto = Search.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // Reset form if params don't exist (e.g. after clearing a search)
        // TODO - probably a better way to do this
        if (prevProps.params && !this.props.params) {
            this.props.reset();
        }
    };
    _proto.render = function render() {
        var _props = this.props, handleSubmit = _props.handleSubmit, onSearch = _props.onSearch, onReset = _props.onReset, showViewAll = _props.showViewAll, fixed = _props.fixed, loading = _props.loading, strings = _props.strings, organization = _props.organization, isLocationListEmpty = _props.isLocationListEmpty, isGeoIpEnabled = _props.isGeoIpEnabled;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSearch, {
                fixed: fixed,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledForm, {
                        onSubmit: handleSubmit(function(values) {
                            return onSearch(values);
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        name: "address",
                                        placeholder: (0,stringHelpers/* safelyGetString */.bc)(strings, "locations.search_placeholder"),
                                        component: searchInput/* SearchInput */.Mj,
                                        icon: "/static/img/icons/search.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLocationIcon, {
                                        type: "button",
                                        onClick: this.getUserLocation,
                                        "aria-label": "Search by my current location",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/static/img/icons/locationArrow.svg",
                                            alt: "Use my location icon"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubmit, {
                                type: "submit",
                                id: "Search__search-btn",
                                "data-testid": "search-address-submit-button",
                                size: "small",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: loading ? "locations.search_cta_loading" : "locations.search_cta"
                                })
                            })
                        ]
                    }),
                    isLocationListEmpty && !isGeoIpEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFindOrgStoreText, {
                                className: "bold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "locations.search_start_cta",
                                    dataObj: {
                                        brandName: organization.label
                                    },
                                    html: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOrUseLocationText, {
                                children: "\xa0or\xa0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUseMyCurrentLocation, {
                                type: "button",
                                onClick: this.getUserLocation,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    children: [
                                        "Use my current location\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Crosshair */.Z.Crosshair, {
                                            title: "location"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    showViewAll && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hr/* StyledHr */.n, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledViewAllWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledViewAll, {
                                    "data-testid": "view-all-locations-link",
                                    onClick: onReset,
                                    className: cssClassNames/* CSS_CLASSES.STORE_LOCATOR.VIEW_ALL_LOCATION_LINK */.Y.STORE_LOCATOR.VIEW_ALL_LOCATION_LINK,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        accessor: "locations.all_locations_cta"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    return Search;
}(react.Component);
var search_mapStateToProps = function(state) {
    return {
        strings: state.app.cmsConfig.strings
    };
};
var search_connector = (0,es.connect)(search_mapStateToProps);
/* harmony default export */ var search = ((0,redux/* compose */.qC)(styled_components_browser_esm/* withTheme */.Zz, search_connector, (0,reduxForm/* default */.Z)({
    form: "locations-search",
    validate: function(values) {
        var errors = {};
        if (!values.address) {
            errors.address = "Zip code or address required";
        }
        return errors;
    }
}))(Search));

// EXTERNAL MODULE: ./src/components/locations/search/storedAddresses/styles.ts
var storedAddresses_styles = __webpack_require__(87375);
// EXTERNAL MODULE: ./src/components/checkout/uielements/primaryButton/index.tsx
var primaryButton = __webpack_require__(84899);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var me_actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
;// CONCATENATED MODULE: ./src/components/locations/search/storedAddresses/index.tsx











var handleSubmitAddress = function(address, searchDeliveryCoverage) {
    var storedAddress = Object.assign({}, address, {
        city: address.city,
        street_address: address.street_address,
        street_address_2: address.street_address_2,
        time_wanted: "asap",
        zip_code: address.zip_code
    });
    storedAddress.id = address.id;
    searchDeliveryCoverage(storedAddress);
};
var _DeliverySearchStoredAddresses = function(param) {
    var myAddresses = param.myAddresses, fetchAddresses = param.fetchAddresses, searchDeliveryCoverage = param.searchDeliveryCoverage, theme = param.theme;
    var ref;
    // Don't show section if feature disabled
    if (!((ref = theme.accounts) === null || ref === void 0 ? void 0 : ref.stored_addresses)) {
        return null;
    }
    (0,react.useEffect)(function() {
        if ((0,auth/* userLoggedIn */.nD)()) {
            fetchAddresses();
        }
    }, []);
    // Don't show section if no stored addresses
    if ((myAddresses === null || myAddresses === void 0 ? void 0 : myAddresses.length) < 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: storedAddresses_styles/* StyledDeliveryFormSubheader */.N,
                accessor: "account.addresses_header",
                html: true
            }),
            myAddresses.map(function(address) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(storedAddresses_styles/* StyledAddressContainer */.D, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    address.street_address,
                                    address.street_address_2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ",\xa0",
                                            address.street_address_2
                                        ]
                                    }),
                                    ",\xa0",
                                    address.city,
                                    ", ",
                                    address === null || address === void 0 ? void 0 : address.zip_code
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                                type: "submit",
                                theme: "primary",
                                submitting: false,
                                handleClick: function() {
                                    return handleSubmitAddress(address, searchDeliveryCoverage);
                                },
                                "aria-label": "Order delivery to ".concat(address.street_address, " ").concat(address.street_address_2, " ").concat(address.city),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    accessor: "locations.delivery_search_addresses_cta"
                                })
                            })
                        ]
                    })
                }, address.id);
            })
        ]
    });
};
var storedAddresses_mapStateToProps = function(state) {
    return {
        myAddresses: state.app.me.myAddresses
    };
};
var mapDispatchToProps = {
    fetchAddresses: me_actions/* default.fetchAddresses */.Z.fetchAddresses,
    searchDeliveryCoverage: actions/* locationsActions.searchDeliveryCoverage */.b.searchDeliveryCoverage
};
var storedAddresses_connector = (0,es.connect)(storedAddresses_mapStateToProps, mapDispatchToProps);
var DeliverySearchStoredAddresses = (0,redux/* compose */.qC)(styled_components_browser_esm/* withTheme */.Zz, storedAddresses_connector)(_DeliverySearchStoredAddresses);

// EXTERNAL MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/autocomplete.tsx
var autocomplete = __webpack_require__(48350);
// EXTERNAL MODULE: ./src/components/fulfillmentManager/deliveryManager/deliveryForm/googautocomplete.tsx
var googautocomplete = __webpack_require__(66630);
;// CONCATENATED MODULE: ./src/components/locations/search/deliverySearch/index.tsx













var DeliverySearch = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DeliverySearch, Component);
    var _super = (0,_create_super/* default */.Z)(DeliverySearch);
    function DeliverySearch() {
        (0,_class_call_check/* default */.Z)(this, DeliverySearch);
        return _super.apply(this, arguments);
    }
    var _proto = DeliverySearch.prototype;
    _proto.render = function render() {
        var _props = this.props, loading = _props.loading, theme = _props.theme, searchDeliveryCoverage = _props.searchDeliveryCoverage;
        var AutocompleteComponent = theme.global.radar_maps ? autocomplete/* default */.Z : googautocomplete/* default */.Z;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteComponent, {
                    loading: loading,
                    apiKey: theme.locations.map_key,
                    checkOrSearchDeliveryCoverage: searchDeliveryCoverage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliverySearchStoredAddresses, {})
            ]
        });
    };
    return DeliverySearch;
}(react.Component);
var deliverySearch_mapStateToProps = function(state) {
    return {
        loading: state.app.locations.searchLoading
    };
};
var deliverySearch_mapDispatchToProps = {
    searchDeliveryCoverage: actions/* locationsActions.searchDeliveryCoverage */.b.searchDeliveryCoverage
};
var deliverySearch_connector = (0,es.connect)(deliverySearch_mapStateToProps, deliverySearch_mapDispatchToProps);
/* harmony default export */ var deliverySearch = ((0,redux/* compose */.qC)(styled_components_browser_esm/* withTheme */.Zz, deliverySearch_connector, (0,reduxForm/* default */.Z)({
    form: "delivery-search"
}))(DeliverySearch));

// EXTERNAL MODULE: ./src/components/reorders/list/index.tsx + 5 modules
var reorders_list = __webpack_require__(64316);
// EXTERNAL MODULE: ./src/components/reorders/list/styles.ts
var list_styles = __webpack_require__(74257);
;// CONCATENATED MODULE: ./src/components/reorders/newOrderHeading/styles.ts




var StyledNewOrderHeading = (0,styled_components_browser_esm/* default */.ZP)(list_styles/* StyledReorderHeading */.rS).withConfig({
    componentId: "sc-8b1b77a5-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.location_search.tertiary_font, [
        "color",
        "font_family",
        "font_size", 
    ]));
});

// EXTERNAL MODULE: ./src/components/uielements/box/box.tsx + 1 modules
var box = __webpack_require__(68801);
// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
;// CONCATENATED MODULE: ./src/components/uielements/ticketIcon/index.tsx


var _TicketIconSvg = function(param) {
    var color = param.color, _size = param.size, size = _size === void 0 ? 24 : _size, theme = param.theme;
    var _color;
    var fallbackColor = (_color = theme.text.primary_font.color) !== null && _color !== void 0 ? _color : "black";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.938 12.625h8.125M7.938 10.125h8.125M4.5 18.25V6.375a.625.625 0 0 1 .625-.625h13.75a.625.625 0 0 1 .625.625V18.25L17 17l-2.5 1.25L12 17l-2.5 1.25L7 17l-2.5 1.25Z",
            stroke: color !== null && color !== void 0 ? color : fallbackColor,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var TicketIconSvg = (0,styled_components_browser_esm/* withTheme */.Zz)(_TicketIconSvg);

;// CONCATENATED MODULE: ./src/components/reorders/newOrderHeading/index.tsx






var NewOrderHeading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
        align: "leading",
        overrides: {
            marginBottom: "var(--size-2)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.x, {
                overrides: {
                    marginTop: "var(--size-1)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketIconSvg, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.x, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNewOrderHeading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            accessor: "reorders.new_order_title",
                            tag: "span"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            tag: "span",
                            accessor: "locations.subheader",
                            html: true
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/uielements/render.tsx
var uielements_render = __webpack_require__(45190);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ./src/services/client.ts
var services_client = __webpack_require__(49741);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
// EXTERNAL MODULE: ./src/utils/magicBox.ts
var utils_magicBox = __webpack_require__(39916);
;// CONCATENATED MODULE: ./src/features/locations/finder.tsx









































/**
 * This is a huge hack to fix a hydration mismatch error with React 18.
 * Basically, it forces the Google Map to render client-side rather than
 * attempting to render it server-side and hydrate on the client.
 *
 * This is currently necessary because the Map needs a big refactor
 * and there are some underlying issues with the
 * `@react-google-maps/api` library that need further investigation.
 */ var ClientSideMap = dynamic_default()(// @ts-expect-error prop mismatch with the dynamic import.
function() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    if (theme.global.radar_maps) {
        return __webpack_require__.e(/* import() */ 206).then(__webpack_require__.bind(__webpack_require__, 12206)).then(function(component) {
            return component.default;
        });
    } else {
        return Promise.all(/* import() */[__webpack_require__.e(889), __webpack_require__.e(2)]).then(__webpack_require__.bind(__webpack_require__, 84002)).then(function(component) {
            return component.default;
        });
    }
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84002)
            ];
        }
    },
    ssr: false
});
var LocationsFinder = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LocationsFinder, Component);
    var _super = (0,_create_super/* default */.Z)(LocationsFinder);
    function LocationsFinder() {
        (0,_class_call_check/* default */.Z)(this, LocationsFinder);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            clickedMapSearch: false,
            hideMapButton: false,
            viewingAllLocations: false,
            handoffMode: dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP
        };
        _this.maybeReceivedAndroidGeoLocation = function(event) {
            clearTimeout(_this.androidGeolocationRequestTimeout);
            var ref = event === null || event === void 0 ? void 0 : event.detail.location, lat = ref.lat, lng = ref.lng;
            // attempt to read the device latitude and longitude
            if (lat && lng) {
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATION_RECOMMENDATIONS_SURFACED */.x.LOCATION_RECOMMENDATIONS_SURFACED, {
                    name: constants/* EventNames.LOCATIONS_SURFACED_GEOLOCATION */.V.LOCATIONS_SURFACED_GEOLOCATION
                });
                _this.onSearch({
                    distance: constants_locations/* LOCATION_OPTIONS.defaultSearchRadius */.pr.defaultSearchRadius,
                    latitude: lat,
                    longitude: lng
                });
            } else {
                // otherwise start the normal ordering app process of using the customer's ip address
                _this.getNearbyLocations();
            }
        };
        /** @TODO improve typing from the brand's `Map` component. */ _this.fetchCenterCoords = function(mapCenterCoords, largestRadialDistance) {
            _this.onSearch({
                distance: largestRadialDistance,
                latitude: mapCenterCoords[0],
                longitude: mapCenterCoords[1]
            });
            _this.setState({
                clickedMapSearch: true
            });
        };
        _this.getNearbyLocations = function() {
            var client = (0,services_client/* createHttpClient */.d9)({
                origin: (0,src_utils/* getOrigin */.P$)(window.location.host)
            });
            _this.setState({
                viewingAllLocations: false
            });
            (0,v4/* geoIpLookup */.Cg)({
                client: client
            }).then(function(data) {
                var geoData = data.geoData;
                if (geoData) {
                    (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATION_RECOMMENDATIONS_SURFACED */.x.LOCATION_RECOMMENDATIONS_SURFACED, {
                        name: constants/* EventNames.LOCATIONS_SURFACED_IPADDRESS */.V.LOCATIONS_SURFACED_IPADDRESS
                    });
                    _this.onSearch({
                        distance: constants_locations/* LOCATION_OPTIONS.defaultSearchRadius */.pr.defaultSearchRadius,
                        latitude: geoData.ll[0],
                        longitude: geoData.ll[1]
                    });
                } else {
                    (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATION_RECOMMENDATIONS_SURFACED */.x.LOCATION_RECOMMENDATIONS_SURFACED, {
                        name: constants/* EventNames.LOCATIONS_SURFACED_DEFAULT */.V.LOCATIONS_SURFACED_DEFAULT
                    });
                    _this.getLocations();
                }
            }).catch(function() {
                return _this.getLocations();
            });
        };
        // This controls the "Search this area" button visibility
        _this.showMapButton = function() {
            if (_this.state.hideMapButton) {
                _this.setState({
                    hideMapButton: false
                });
            }
        };
        _this.getLocations = function(page, viewAll) {
            var _props = _this.props, fetchLocations = _props.fetchLocations, fetchAllLocations = _props.fetchAllLocations;
            // Assign magicbox parameters
            var magicBox = new utils_magicBox/* MagicBoxParams */.t().setPagination(page !== null && page !== void 0 ? page : 1, 50).setSorts({
                state_id: "asc",
                label: "asc"
            }).setIncludes([
                "operating_hours",
                "attributes",
                "delivery_hours",
                "business_hours", 
            ]);
            if (viewAll) {
                fetchAllLocations(magicBox);
            } else {
                fetchLocations(magicBox);
            }
            _this.setState({
                clickedMapSearch: false,
                hideMapButton: true
            });
        };
        _this.handleViewAll = function() {
            // clear any previous search results (to remove the search radius heading) before viewing all
            _this.props.clearLocations();
            var groupedLocations = (0,stringHelpers/* safelyGetConfig */.K6)(_this.props.webConfig, "locations.list_display") === constants_locations/* LOCATIONS_CONFIG.ALL_DISPLAY.GROUP_BY_STATE */.u.ALL_DISPLAY.GROUP_BY_STATE;
            // @ts-expect-error @TODO differentiate between `null` and `undefined`.
            _this.getLocations(null, groupedLocations);
            _this.setState({
                viewingAllLocations: true
            });
            // Events
            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATIONS__VIEW_ALL_LOCATIONS */.x.LOCATIONS__VIEW_ALL_LOCATIONS);
        };
        _this.handleTabKeyDown = function(event, targetHandoffMode) {
            var handoffMode = _this.state.handoffMode;
            switch(event.key){
                case "ArrowLeft":
                    event.preventDefault();
                    if (handoffMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY) {
                        _this.setState({
                            handoffMode: dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP
                        });
                    }
                    break;
                case "ArrowRight":
                    event.preventDefault();
                    if (handoffMode === dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP) {
                        _this.setState({
                            handoffMode: dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                        });
                    }
                    break;
                case "Enter":
                case " ":
                    event.preventDefault();
                    _this.setState({
                        handoffMode: targetHandoffMode
                    });
                    break;
            }
        };
        _this.onSearch = function(values, previousAction) {
            // Assign magicbox parameters
            var magicBox = new utils_magicBox/* MagicBoxParams */.t().setPagination(1, 50).setSorts({
                state_id: "asc"
            }).setIncludes([
                "operating_hours",
                "attributes",
                "delivery_hours",
                "business_hours", 
            ]);
            _this.props.searchLocations(magicBox, values, previousAction, dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP);
            _this.setState({
                clickedMapSearch: false,
                hideMapButton: true,
                viewingAllLocations: false
            });
        };
        return _this;
    }
    var _proto = LocationsFinder.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        if (this.props.webConfig.global.default_conveyance_type && dist/* CONVEYANCE_TYPES */.P8[this.props.webConfig.global.default_conveyance_type] !== this.state.handoffMode) {
            this.setState({
                handoffMode: dist/* CONVEYANCE_TYPES */.P8[this.props.webConfig.global.default_conveyance_type]
            });
        }
        if ((0,android/* isAndroidShell */.Y2)()) {
            try {
                // getGeolocation can fail if the Android app has not given geolocation permissions
                window.KoalaAndroidShell.getGeolocation();
                window.addEventListener("android/geolocationUpdated", this.maybeReceivedAndroidGeoLocation);
                this.androidGeolocationRequestTimeout = setTimeout(function() {
                    // fallback to IP geolocation after a timeout
                    if (_this.props.webConfig.locations.geoip) {
                        _this.getNearbyLocations();
                    }
                }, 5000);
            } catch (error) {
                errorReporter/* captureException */.Tb(error);
                // fallback to IP geolocation after an error
                if (this.props.webConfig.locations.geoip) {
                    this.getNearbyLocations();
                }
            }
        } else {
            if (this.props.webConfig.locations.geoip) {
                this.getNearbyLocations();
            }
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var handoffMode = this.state.handoffMode;
        if (prevState.handoffMode !== handoffMode) {
            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.DELIVERY__TOGGLE */.x.DELIVERY__TOGGLE, {
                name: handoffMode
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.clearLocations();
        clearTimeout(this.androidGeolocationRequestTimeout);
        window.removeEventListener("android/geolocationUpdated", this.maybeReceivedAndroidGeoLocation);
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, data = _props.data, webConfig = _props.webConfig, activeLocationId = _props.activeLocationId, params = _props.params, meta = _props.meta, loading = _props.loading, searchLoading = _props.searchLoading, moreLocationsLoading = _props.moreLocationsLoading, searchTimestamp = _props.searchTimestamp, viewState = _props.viewState, list = _props.list, setActiveLocation = _props.setActiveLocation, organization = _props.organization;
        var shouldShowLoyaltyAccessor = typeof this.props.webConfig.global.loyalty_accessor === "undefined" ? true : this.props.webConfig.global.loyalty_accessor;
        var _state = this.state, clickedMapSearch = _state.clickedMapSearch, hideMapButton = _state.hideMapButton, handoffMode = _state.handoffMode;
        var currentPage = get_default()(meta, "pagination.current_page");
        // Optional Delivery Search
        var deliverySearchEnabled = webConfig.locations.delivery_search;
        var me = data;
        var isLocationListEmpty = !list || !list.length;
        var showViewAllCTA = viewState !== constants_locations/* LOCATION_VIEW_STATES.VIEW_ALL */.w6.VIEW_ALL && // Not the view all state.
        !this.state.viewingAllLocations && !loading && !searchLoading && // is not in a loading state
        (!params || Boolean(params) && list && list.length > 0); // Is not in a state where the search returned empty. That is because the other load cta button will show up in that case.
        var MapComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSideMap, {
            // @ts-expect-error prop mismatch with the dynamic import.
            activeLocationId: activeLocationId,
            locations: list,
            setActiveLocation: setActiveLocation,
            locationSearchTimestamp: searchTimestamp,
            fetchCenterCoords: this.fetchCenterCoords,
            hideMapButton: hideMapButton,
            showMapButton: this.showMapButton
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
            disabled: webConfig.locations.disable_locations_page,
            pageName: "locations",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationsLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationsLayoutList, {
                            className: cssClassNames/* CSS_CLASSES.LOCATION_LIST.CONTAINER */.Y.LOCATION_LIST.CONTAINER,
                            children: [
                                (me === null || me === void 0 ? void 0 : me.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    tag: "h1",
                                    accessor: "locations.header_user",
                                    html: true,
                                    dataObj: me
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    tag: "h1",
                                    accessor: "locations.header_guest",
                                    html: true
                                }),
                                shouldShowLoyaltyAccessor && /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                    checkType: loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                    checkName: loyalty/* LOYALTY_FEATURES.GET_AVAILABLE_REWARDS */.lw.GET_AVAILABLE_REWARDS,
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsRewardsSummary, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(featureAccessor/* FeatureAccessor */.R, {
                                    featureFlag: features/* FEATURE_FLAGS.ME__REORDER */.y8.ME__REORDER,
                                    renderFallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            margin: "20px 0 0"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            tag: "div",
                                            accessor: "locations.subheader",
                                            html: true
                                        })
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsReorders, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reorders_list/* ReorderList */.L, {
                                                ordersToDisplay: 5
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewOrderHeading, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                    condition: deliverySearchEnabled,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationsHandoffToggle, {
                                        "aria-label": "Handoff Toggle",
                                        role: "tablist",
                                        handoffMode: handoffMode,
                                        style: {
                                            marginTop: styles/* LAYOUT.GUTTER */._.GUTTER
                                        },
                                        className: cssClassNames/* CSS_CLASSES.LOCATION_LIST.HANDOFF_TOGGLE */.Y.LOCATION_LIST.HANDOFF_TOGGLE,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsHandoffToggleButton, {
                                                "aria-selected": handoffMode === dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP,
                                                role: "tab",
                                                "aria-controls": "non-delivery-tab",
                                                active: handoffMode === dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP,
                                                onClick: function() {
                                                    return _this.setState({
                                                        handoffMode: dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP
                                                    });
                                                },
                                                onKeyDown: function(event) {
                                                    return _this.handleTabKeyDown(event, dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP);
                                                },
                                                tabIndex: handoffMode === dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP ? 0 : -1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                    accessor: "locations.search_tab_default_text",
                                                    html: true,
                                                    tag: "span"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsHandoffToggleButton, {
                                                "aria-selected": handoffMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY,
                                                role: "tab",
                                                "aria-controls": "delivery-tab",
                                                active: handoffMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY,
                                                onClick: function() {
                                                    return _this.setState({
                                                        handoffMode: dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                                                    });
                                                },
                                                onKeyDown: function(event) {
                                                    return _this.handleTabKeyDown(event, dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY);
                                                },
                                                tabIndex: handoffMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY ? 0 : -1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                    accessor: "locations.search_tab_delivery_text",
                                                    html: true,
                                                    tag: "span"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                    condition: handoffMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY && deliverySearchEnabled,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "tabpanel",
                                        id: "delivery-tab",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsDeliverySearch, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(deliverySearch, {})
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                    condition: handoffMode !== dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "tabpanel",
                                        id: "non-delivery-tab",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FixOnScroll, {
                                                fromTop: styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT,
                                                id: "LocationSearch",
                                                minWidth: 767,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
                                                    onSearch: this.onSearch,
                                                    getNearbyLocations: this.getNearbyLocations,
                                                    onReset: this.handleViewAll,
                                                    params: params,
                                                    loading: searchLoading,
                                                    showViewAll: showViewAllCTA,
                                                    initialValues: {
                                                        distance: constants_locations/* LOCATION_OPTIONS.defaultSearchRadius */.pr.defaultSearchRadius
                                                    },
                                                    locationViewState: viewState,
                                                    handoffMode: handoffMode,
                                                    organization: organization,
                                                    isLocationListEmpty: isLocationListEmpty,
                                                    isGeoIpEnabled: this.props.webConfig.locations.geoip
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                                condition: searchLoading || loading,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIndicator, {
                                                        className: "pad",
                                                        children: "Searching for locations..."
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsHeading, {
                                                onSearch: this.onSearch,
                                                isLoading: searchLoading,
                                                locationViewState: viewState,
                                                locations: list,
                                                // @ts-expect-error @TODO ensure that `params` are not null.
                                                locationParams: params,
                                                locationsMeta: meta,
                                                clickedMapSearch: clickedMapSearch
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutListSection, {
                                                "data-testid": "locators-list-section",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                                        condition: searchLoading,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationsNoResults, {
                                                            children: [
                                                                "Searching for ",
                                                                (0,stringHelpers/* pluralizeString */.fB)(organization.label),
                                                                " in your area."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                                        condition: Boolean(params && list && !list.length && !searchLoading),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationsNoResults, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        paddingBottom: "".concat(styles/* LAYOUT.GUTTER */._.GUTTER, "px")
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                                        accessor: "locations.no_results",
                                                                        html: true,
                                                                        dataObj: {
                                                                            brandName: organization.label
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsViewAll, {
                                                                    onClick: this.handleViewAll,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                                        accessor: "locations.all_locations_cta",
                                                                        className: cssClassNames/* CSS_CLASSES.STORE_LOCATOR.VIEW_ALL_LOCATION_LINK */.Y.STORE_LOCATOR.VIEW_ALL_LOCATION_LINK
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(results, {
                                                        // @ts-expect-error @TODO ensure that `activeLocationId` isn't null.
                                                        activeLocationId: activeLocationId,
                                                        locations: list,
                                                        setActiveLocation: setActiveLocation,
                                                        displayType: viewState
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                                        condition: moreLocationsLoading,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingIndicator, {
                                                                children: "Loading more locations..."
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements_render/* Render */.H, {
                                                        condition: Boolean(!moreLocationsLoading && meta && meta.pagination && currentPage < meta.pagination.total_pages),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsViewAll, {
                                                            onClick: function() {
                                                                return _this.getLocations(currentPage + 1);
                                                            },
                                                            children: "View More Locations"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsLayoutMap, {
                            children:  true && !window.matchMedia("(max-width: 767px)").matches && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: MapComponent
                            })
                        })
                    ]
                })
            })
        });
    };
    return LocationsFinder;
}(react.Component);
var finder_mapStateToProps = function(state) {
    return {
        organization: state.app.organization.organization,
        activeLocationId: state.app.locations.activeLocationId,
        params: state.app.locations.params,
        meta: state.app.locations.meta,
        loading: state.app.locations.loading,
        searchLoading: state.app.locations.searchLoading,
        moreLocationsLoading: state.app.locations.moreLocationsLoading,
        searchTimestamp: state.app.locations.searchTimestamp,
        viewState: state.app.locations.viewState,
        list: state.app.locations.list,
        webConfig: state.app.cmsConfig.webConfig,
        data: state.app.me.data
    };
};
var finder_mapDispatchToProps = {
    fetchLocations: actions/* locationsActions.fetchLocations */.b.fetchLocations,
    fetchAllLocations: actions/* locationsActions.fetchAllLocations */.b.fetchAllLocations,
    searchLocations: actions/* locationsActions.searchLocations */.b.searchLocations,
    setActiveLocation: actions/* locationsActions.setActiveLocation */.b.setActiveLocation,
    clearLocations: actions/* locationsActions.clearLocations */.b.clearLocations
};
var finder_connector = (0,es.connect)(finder_mapStateToProps, finder_mapDispatchToProps);
/* harmony default export */ var finder = ((0,redux/* compose */.qC)(finder_connector, router.withRouter)(LocationsFinder));


/***/ })

}]);